
import themeConfig from "../../../configs/themeConfig"

const SpinnerComponent = () => {
  return (
    <div className="fallback-spinner" style={{
      minHeight: '150px'
    }}>
      <div className="loading">
        {/* <div className="effect-1 effects"></div>
        <div className="effect-2 effects"></div>
        <div className="effect-3 effects"></div> */}
        <img src={themeConfig.app.ziploader} />
      </div>
    </div >
  )
}

export default SpinnerComponent
